(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("openstack-uicore-foundation", [], factory);
	else if(typeof exports === 'object')
		exports["openstack-uicore-foundation"] = factory();
	else
		root["openstack-uicore-foundation"] = factory();
})(this, () => {
return 